import { createSelector } from 'reselect'

const getData = (state, selector) => {
  const data = state.GroupsStore ? state.GroupsStore : state
  return !data ? null : selector(data)
}

const getGroupsFetchingStatus = state => getData(state, data => data.fetching)

const getGroups = state =>
  getData(
    state,
    data => (data.groups.entities ? data.groups.entities.groups : {})
  )

const getCategories = state => getData(state, data => data.categories || [])

const getGroup = (state, id) => getGroups(state)[id] || null

const getGroupsResult = state =>
  getData(state, data => data.groups.result || [])

const getGroupsArray = createSelector(
  [getGroups, getGroupsResult],
  (groups, result) => (!groups || !result ? [] : result.map(id => groups[id]))
)

const getUpdatableGroupsArray = createSelector([getGroupsArray], groups =>
  groups.filter(group => group.policy.can_manage_students_for_group)
)

const getCustomGroupsArray = createSelector([getGroupsArray], groups =>
  groups.filter(group => group.provider_type === 'CUSTOM')
)

const getGroupsDeletingStatuses = state => getData(state, data => data.deleting)

const getGroupDeletingStatus = (state, id) =>
  getGroupsDeletingStatuses(state)[id] || {
    pending: false,
    requestError: false
  }

const getGroupCreatingStatus = state => getData(state, data => data.creating)

const getGroupsUpdatingStatuses = state => getData(state, data => data.updating)

const getGroupUpdatingStatus = (state, id) =>
  getGroupsUpdatingStatuses(state)[id] || {
    pending: false,
    requestError: false
  }

export {
  getGroups,
  getUpdatableGroupsArray,
  getGroupsResult,
  getGroupsArray,
  getCustomGroupsArray,
  getGroupsFetchingStatus,
  getGroup,
  getGroupDeletingStatus,
  getGroupCreatingStatus,
  getGroupUpdatingStatus,
  getCategories
}
